import { render, staticRenderFns } from "./GoingToLabel.vue?vue&type=template&id=70ba2c8a"
import script from "./GoingToLabel.vue?vue&type=script&lang=ts"
export * from "./GoingToLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports